import home from "@/views/home.vue";
import hotelList from "@/views/hotel/hotelList.vue";
import hotelType from "@/views/hotel/hotelType.vue";
import member from "@/views/account/member.vue";
import role from "@/views/account/role.vue";
import login from "@/views/login.vue";
import washingMachineSetting from "@/views/washingMachine/washingMachineSetting.vue";
import washingMachineList from "@/views/washingMachine/washingMachineList.vue";

import entryLog from "@/views/logs/entryLog";
import operationLog from "@/views/logs/operationLog";
const routes = [
  {
    path: "/",
    redirect: (to) => {
      return "/home";
    },
  },
  {
    path: "/login",
    component: login,
  },
  {
    path: "/account",
    name: "账号",
    pathName: "account",
    component: home,
    redirect: "/account/member",
    icon:'account',
    pages: [101,102],
    children: [
      {
        path: "",
        name: "空路径",
        redirect: "/account/member",
      },
      {
        path: "/account/role",
        name: "用户组管理",
        pages: [101],
        pathName: "role",
        component: role,
      },
      {
        path: "/account/member",
        name: "用户管理",
        pages: [102],
        pathName: "member",
        component: member,
      },
      
    ],
  },
  {
    path: "/home",
    name: "门店",
    pathName: "home",
    component: home,
    redirect: "/home/hotelList",
    icon:'hotel',
    pages: [201,202],
    children: [
      {
        path: "",
        name: "空路径",
        redirect: "/home/hotelList",
      },
      {
        path: "/home/hotelType",
        name: "门店类型",
        pages: [201],
        pathName: "hotelType",
        component: hotelType,
      },
      {
        path: "/home/hotelList",
        name: "门店列表",
        pages: [202],
        pathName: "hotelList",
        component: hotelList,
      },
    ],
  },
  {
    path: "/washingMachine",
    name: "洗衣机",
    pathName: "washingMachine",
    component: home,
    redirect: "/washingMachine/washingMachineSetting",
    icon:'washingMachine',
    pages: [301,302],
    children: [
      {
        path: "",
        name: "空路径",
        redirect: "/washingMachine/washingMachineSetting",
      },
      {
        path: "/washingMachine/washingMachineSetting",
        name: "厂商配置",
        pages: [301],
        pathName: "washingMachineSetting",
        component: washingMachineSetting,
      },
      {
        path: "/washingMachine/washingMachineList",
        name: "设备管理",
        pages: [302],
        pathName: "washingMachineList",
        component: washingMachineList,
      },
    ],
  },
  {
    path: "/logs",
    name: "日志",
    pathName: "logs",
    component: home,
    redirect: "/logs/entryLog",
    icon:'logs',
    pages: [401,402],
    children: [
      {
        path: "",
        name: "空路径",
        redirect: "/logs/entryLog",
      },
      {
        path: "/logs/entryLog",
        name: "登录日志",
        pages: [401],
        pathName: "entryLog",
        component: entryLog,
      },
      {
        path: "/logs/operationLog",
        name: "操作日志",
        pages: [402],
        pathName: "operationLog",
        component: operationLog,
      },
    ],
  },
  // 其他路由
  {
    path: "/:pathMatch(.*)*", // 通配符路由
    redirect: "/",
  },
];

export default routes;
